import React from 'react'
import { M_CheckBox, M_InputTextField } from 'src/components/M_Components'

export default function RORO({ optionsRORO, ROROMap, createStructure, t }) {

    return (
        <div className='cardOrderService'>
            <div className='divTitleCard'>
                <div className='divAlignTitleStatus'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/box.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Container"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("ROROInformation")}
                    </div>
                </div>
            </div>
            <div className='divGridOrderService'>
                {optionsRORO.filter((elem) => elem.IsHiddenList !== true).map((elem3, key3) => (
                    <div key={key3}>
                        {elem3.Type === 'string' ? (
                            <M_InputTextField
                                type={"text"}
                                label={elem3.NormalizedName}
                                required={elem3.IsRequired}
                                disabled={elem3.disable}
                                onChange={(e) => createStructure(e.target.value, elem3.Name, 'RORO')}
                                value={ROROMap[elem3.Name] || ""}
                            />
                        ) : elem3.Type === 'boolean' ? (
                            <div className='divCheckboxFormQuotes'>
                                <M_CheckBox
                                    label={elem3.NormalizedName}
                                    onChange={(e) => createStructure(e.target.checked, elem3.Name, 'RORO')}
                                    checked={ROROMap[elem3.Name] || false}
                                    required={elem3.IsRequired}
                                />
                            </div>
                        ) : elem3.Type === 'int32' ? (
                            <M_InputTextField
                                type={"number"}
                                label={elem3.NormalizedName}
                                required={elem3.IsRequired}
                                disabled={elem3.disable}
                                onChange={(e) => createStructure(e.target.value, elem3.Name, 'RORO')}
                                value={ROROMap[elem3.Name] || ""}
                            />
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    )
}
